import { render, staticRenderFns } from "./FlightSearchTabs.vue?vue&type=template&id=50a3239b"
import script from "./FlightSearchTabs.vue?vue&type=script&lang=js"
export * from "./FlightSearchTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports